import { ApiResponseError, OfflineRequestError } from 'utils/errorCodes'

export type TAuthRequestFailure = 'rateLimited' | 'rejected' | 'unreachable' | 'unknown'

// What fetch's TypeError says when it can't connect in Chrome, Safari and Firefox (the set sentry.ts ignores).
// apiFetch rethrows it as is when the browser still reports itself online; any other TypeError is a bug
const FETCH_NETWORK_ERROR_MESSAGES = [
  /^Failed to fetch$/,
  /^Load failed$/,
  /^The network connection was lost\.?$/,
  /^NetworkError when attempting to fetch resource\.?$/,
]

const isFetchNetworkError = (error: unknown) =>
  error instanceof TypeError && FETCH_NETWORK_ERROR_MESSAGES.some((pattern) => pattern.test(error.message))

export const getAuthRequestFailure = (error: unknown): TAuthRequestFailure => {
  if (error instanceof ApiResponseError) {
    if (error.statusCode === 429) return 'rateLimited'

    if (error.statusCode === 401) return 'rejected'

    return 'unknown'
  }

  if (error instanceof OfflineRequestError || isFetchNetworkError(error)) return 'unreachable'

  return 'unknown'
}
